module.exports = __webpack_public_path__ + "static/media/screenshot-competition-submission-main-page.f0e55d5c.png";